angular.module('lf.common')

.factory('siteService', function (preloadData) {
  
  var siteService = {
    getSiteData: function (siteId) {
      var siteData = 
        (siteId && preloadData.sisterSite && (siteId === preloadData.sisterSite.siteId)) ?
        preloadData.sisterSite :
        preloadData;
      return siteData;
    }
  };
  return siteService;
});
